import { aTrack } from '../primitives/a-track';
class VariousEvents {
    constructor() {
        this.options = {
            origin: 'various',
        };
    }
    switched_theme(old_theme, new_theme) {
        aTrack('switched_theme', Object.assign({ old_theme, new_theme }, this.options));
    }
}
export function createVariousEvent() {
    return new VariousEvents();
}
//# sourceMappingURL=various-event.js.map